export default __webpack_public_path__ + "static/media/NU.f10f25ca.svg";